jQuery(function($)
{
    var
        // Pseudo-Constants
        classSelected = 'selected',
        requestUriReplacePattern = '[searchterm]',
        requestUriLanguagePattern = '[language]',
        listItemTermReplacePattern = '[term]',
        listItemTermUriReplacePattern = '[termUri]',
        listItemHitsReplacePattern = '[hits]',
        resultMatchPrefix = '<span class="suggestion text--bold">',
        resultMatchPostfix = '</span>',

        // module-global variables
        { hide } = orion,
        { show } = orion,
        $container = $('.auto-search');

    $container.each(function()
    {
        var
            $container = $(this),
            $input = $('.auto-input', $container),
            minTermLength = $input.data('autosuggest-activate-count'),
            requestUriPattern = $input.data('autosuggest-request-uri-pattern'),
            $suggestionsContainer = $('.suggestions', $container),
            idLastRequest = 0,
            $form = $('form', $container),
            action = $form.attr('action'),
            method = $form.attr('method'),
            language = $('html').attr('lang')
                .toUpperCase(),
            cancelState = false,
            lastSearch = {
                'term': null,
                'result': []
            },
            selectedState = {
                'termIndex': -1,
                'countTerms': 0,
                'visible': false
            },
            listItemPattern
				= '<li><a data-result="' + listItemTermUriReplacePattern + '" href="' + action + '?'
				+ $input.attr('name') + '=' + listItemTermUriReplacePattern + '">'
                + '<i class="fa-regular fa-search"></i> '
				+ listItemTermReplacePattern
				+ '</a></li>';

        // if autosuggest markup structure is not present, bail immediately
        if ($input.length === 0)
        {
            return;
        }

        if ($suggestionsContainer.not('button').length === 0)
        {
            return;
        }

        function map(list, f)
        {
            var
                i, l,
                result = [];

            for (i = 0, l = list.length; i < l; i += 1)
            {
                result[i] = f(list[i]);
            }

            return result;
        }

        function getRequestUri(language, searchTerm)
        {
            return requestUriPattern
                .replace(requestUriLanguagePattern, language)
                .replace(requestUriReplacePattern, encodeURIComponent(searchTerm));
        }

        function makeRequestPromise(language, searchTerm)
        {
            var
                requestUri = getRequestUri(language, searchTerm),
                requestId = idLastRequest + 1,

                request = $.ajax({
                    'cache': true,
                    'dataType': 'json',
                    'url': requestUri
                });

            request.requestId = requestId;
            idLastRequest += 1;

            return request;
        }

        function unpacked(packedList)
        {
            var
                i, l,
                unpackedList = [];

            for (i = 0, l = packedList.length; i < l; i += 2)
            {
                unpackedList.push({
                    'term': packedList[i],
                    'hits': packedList[i + 1]
                });
            }

            return unpackedList;
        }

        function matchWrapped(term, from, length)
        {
            var termType = '';
            var productNumberRegEx = /^\d{11}$/;
            var ean13CodeRegEx = /^\d{13}$/;

            if (productNumberRegEx.test(term))
            {
                termType = languageVarsJS['prefixProductNumber'] + ' ';
            }
            else if (ean13CodeRegEx.test(term))
            {
                termType = languageVarsJS['prefixEan'] + ' ';
            }
            return termType + term.slice(0, from) + resultMatchPrefix + term.slice(from, from + length)
				+ resultMatchPostfix + term.slice(from + length);
        }

        function toListItem(termHits)
        {
            return listItemPattern
                .replace(listItemTermReplacePattern, matchWrapped(termHits.term, termHits.from, termHits.length))
                .replace(listItemTermUriReplacePattern, encodeURIComponent(termHits.term))
                .replace(listItemTermUriReplacePattern, encodeURIComponent(termHits.term))
                .replace(listItemHitsReplacePattern, termHits.hits);
        }

        function addMatchIndicesMap(searchTerm)
        {
            return function(termHits)
            {
                termHits.from = termHits.term.toLowerCase().indexOf(searchTerm);
                termHits.length = searchTerm.length;

                return termHits;
            };
        }

        function handleInputEvent()
        {
            var
                searchTerm = $input.val(),
                request;

            if (searchTerm.length < minTermLength)
            {
                hide($suggestionsContainer);
                selectedState.visible = false;
                updateSelectedView(selectedState);
                lastSearch.term = null;
                lastSearch.result = [];
                return;
            }

            request = makeRequestPromise(language, searchTerm);

            request
                .done(function(response)
                {
                    if (idLastRequest !== request.requestId || cancelState)
                    {
                        /*
						 * stale request => discard
						 * search event (canceled search) happened
						 */
                        return;
                    }

                    var
                        packedTerms = response.terms,
                        unpackedTerms,
                        termsLanguage,
                        matchIndexedTerms,
                        listItems;

                    for (termsLanguage in packedTerms)
                    {
                        if (Object.prototype.hasOwnProperty.call(packedTerms, termsLanguage))
                        {
                            unpackedTerms = unpacked(packedTerms[termsLanguage]);

                            /*
							 * If no results are found, keep the last
							 * successful autosuggestion results visible
							 * by storing the last successful results
							 */
                            if (unpackedTerms.length > 0)
                            {
                                lastSearch.term = searchTerm;
                                lastSearch.result = unpackedTerms;
                            }
                            else if (lastSearch.result && lastSearch.result.length > 0)
                            {
                                searchTerm = lastSearch.term;
                                unpackedTerms = lastSearch.result;
                            }
                        }
                    }

                    selectedState.TermIndex = -1;
                    selectedState.countTerms = unpackedTerms.length;

                    matchIndexedTerms = map(unpackedTerms, addMatchIndicesMap(searchTerm.toLowerCase()));
                    listItems = map(matchIndexedTerms, toListItem);

                    $('ul', $suggestionsContainer).remove();

                    $($suggestionsContainer)
                        .append('<ul>' + listItems.join('') + '</ul>');

                    if (listItems.length === 0)
                    {
                        selectedState.visible = false;
                    }
                    else
                    {
                        selectedState.visible = true;
                    }

                    updateSelectedView(selectedState);
                })
                .fail(function()
                {
                    selectedState.visible = false;
                    updateSelectedView(selectedState);
                });
        }

        function updateSelectedView(selectedState)
        {
            if (selectedState.visible)
            {
                show($suggestionsContainer);
            }
            else
            {
                selectedState.termIndex = -1;
                hide($suggestionsContainer);
            }

            $('ul li a', $suggestionsContainer)
                .removeClass(classSelected);

            if (selectedState.termIndex > -1)
            {
                $('ul li a', $suggestionsContainer)
                    .eq(selectedState.termIndex)
                    .addClass(classSelected)
                    .focus();
            }
        }

        function handleArrowDown(selectedState)
        {
            if ($input.val().length < 2 || selectedState.countTerms === 0)
            {
                return selectedState;
            }

            return $.extend(selectedState, {
                'termIndex': Math.min(selectedState.termIndex + 1, selectedState.countTerms - 1),
                'visible ': true
            });
        }

        function handleArrowUp(selectedState)
        {
            if ($input.val().length < 2 || selectedState.countTerms === 0)
            {
                return selectedState;
            }

            return $.extend(selectedState, {
                'termIndex': Math.max(selectedState.termIndex - 1, -1),
                'visible': true
            });
        }

        function handleEscape(selectedState)
        {
            return $.extend(selectedState, {
                'termIndex': -1,
                'visible': false
            });
        }

        function handleTab(selectedState)
        {
            return $.extend(selectedState, {
                'visible': false
            });
        }

        function handleKeyDownEvent(e)
        {
            cancelState = false;

            if (!selectedState || selectedState.countTerms === 0)
            {
                return;
            }

            switch (e.keyCode)
            {
            // case "Tab":
            case 9:
                selectedState = handleTab(selectedState);
                break;
                // case "Return"
            case 13:
                if (selectedState.termIndex > -1)
                {
                    window.location.href = $suggestionsContainer.find('a.' + classSelected).attr('href');
                    e.preventDefault();
                }
                break;
                /*
				 * case "Esc":
				 * case "Escape":
				 */
            case 27:
                selectedState = handleEscape(selectedState);
                break;
                /*
				 * case "Up":
				 * case "ArrowUp":
				 */
            case 38:
                e.preventDefault();
                selectedState = handleArrowUp(selectedState);
                break;
                /*
				 * case "Down":
				 * case "ArrowDown":
				 */
            case 40:
                e.preventDefault();
                selectedState = handleArrowDown(selectedState);
                break;
            default:
                selectedState.termIndex = -1;
                updateSelectedView(selectedState);
                $input.focus();
                return;
            }

            updateSelectedView(selectedState);
        }

        function submitForm(data)
        {
            var name;

            for (name in data)
            {
                if (Object.prototype.hasOwnProperty.call(data, name))
                {
                    $('[name="' + name + '"]', $form).val(data[name]);
                }
            }

            $('[type=submit]', $form).each(function()
            {
                var $submit = $(this);

                $form.append('<input name="' + $submit.attr('name') + '" type="hidden" />');
            });

            $form.get(0).submit();
        }

        function handleClickResult(e)
        {
            var
                $this = $(this),
                data = {};

            if (method.toUpperCase() === 'POST')
            {
                e.preventDefault();

                data[$input.attr('name')] = $this.data('result');
                submitForm(data);
            }
        }

        function handleClickResultsContainer(e)
        {
            e.stopPropagation();
        }

        function handleClickFocusOverlay()
        {
            selectedState.visible = false;
            hide($suggestionsContainer);
        }

        function handleMouseenter()
        {
            var selectedIndex = $('li', $suggestionsContainer).index(this);

            selectedState.termIndex = selectedIndex;
            updateSelectedView(selectedState);
        }

        $input
            .on('search', function()
            {
                cancelState = true;
            })
            .on('input', handleInputEvent)
            .on('keydown', handleKeyDownEvent);

        $suggestionsContainer
            .on('keydown', handleKeyDownEvent)
            .on('mouseenter', 'li', handleMouseenter)
            .on('click', 'a', handleClickResult)
            .on('click', handleClickResultsContainer);

        $('body').on(orion.constants.EventFocusOverlayClicked, handleClickFocusOverlay);
    });
});
